var pug = require("!../../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ch1 class=\"ribbon\" ng-if=\"text\"\u003E\u003Cspan class=\"ribbon-content\" ng-bind-html=\"sce.trustAsHtml(text)\"\u003E\u003C\u002Fspan\u003E\u003C\u002Fh1\u003E";;return pug_html;};
module.exports = template;